import React from 'react';
import {OverviewGridQuote, OverviewGridQuoteProps} from './OverviewGrid.quote';
import {
    OutlinedCard,
    OutlinedCardProps,
    ImageRatioOptions,
    ImageCard,
    ImageCardProps,
    NewsletterCard,
    CmsComponentMapper,
    CmsDynamicArray,
    ExploreCard,
    ExploreCardProps,
    ContactCard,
    ContactCardProps
} from '../../elements';
import {AccentColorOptions} from 'epic-ue-theme';
import {NewsletterProps} from '../../../types';

export type OverviewGridBottomLeftOptions =
    | OverviewGridQuoteProps
    | ImageCardProps
    | OutlinedCardProps
    | ExploreCardProps
    | NewsletterProps
    | ContactCardProps;

export type OverviewGridBottomLeftOptionsArray =
    | CmsDynamicArray<OverviewGridBottomLeftOptions>
    | undefined;

export type OverviewGridBottomLeftProps = {
    dynamicPageDataArray: OverviewGridBottomLeftOptionsArray;
    imageRatioOverride?: ImageRatioOptions;
    accentColor?: AccentColorOptions;
    disableDescription?: boolean;
    _type?: string;
    hideBottomPadding?: boolean;
};

export const OverviewGridBottomLeft = ({
    dynamicPageDataArray,
    imageRatioOverride,
    accentColor,
    disableDescription,
    hideBottomPadding
}: OverviewGridBottomLeftProps): JSX.Element => {
    const imageCardOverrides: ImageCardProps = {};
    const newsletterCardOverrides = {} as NewsletterProps;
    if (disableDescription) {
        imageCardOverrides.description = undefined;
    }
    return (
        <CmsComponentMapper
            dynamicPageDataArray={dynamicPageDataArray}
            elementMapping={{
                quoteSlot: <OverviewGridQuote accentColor={accentColor} />,
                imageSlot: (
                    <ImageCard
                        imageRatioOverride={imageRatioOverride}
                        {...imageCardOverrides}
                        accentColor={accentColor}
                        paragraphCaption={false}
                        hideBottomPadding={hideBottomPadding}
                    />
                ),
                cardSlot: <OutlinedCard accentColor={accentColor} />,
                exploreSlot: <ExploreCard accentColor={accentColor} />,
                newsletterSlot: (
                    <NewsletterCard accentColor={accentColor} {...newsletterCardOverrides} />
                ),
                contactSlot: <ContactCard accentColor={accentColor} />
            }}
        />
    );
};
